import api from './axiosConfig';

export const businessApi = {
  getBusinesses: () => api.get('/v1/businesses'),
  createBusiness: (data) => api.post('/v1/businesses', data),
  updateBusiness: (id, data) => api.put(`/v1/businesses/${id}`, data),
  deleteBusiness: (id) => api.delete(`/v1/businesses/${id}`)
};
